/**
 * Base for hand-drawn icons that sit next to lucide-react ones: same 24px
 * grid, outline only, round caps and joins, `currentColor`. Takes the same
 * props as a lucide icon (`size`, `strokeWidth`, `color`, `className`, `style`).
 */
const CustomIcon = ({ children, color = 'currentColor', size = 24, strokeWidth = 2, ...props }) => (
  <svg
    aria-hidden="true"
    fill="none"
    height={size}
    stroke={color}
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth={strokeWidth}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {children}
  </svg>
);

export default CustomIcon;
